import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'DashboardConfirmAdminNoticeModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.dashboardConfirmAdminNoticeModal.active,

      // model
      values: state => state.dashboardConfirmAdminNoticeModal.values
    }),
    ...mapGetters({
      getValue: 'dashboardConfirmAdminNoticeModal/getValue'
    }),
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      loadModel: 'dashboardConfirmAdminNoticeModal/loadModel',
      hide: 'dashboardConfirmAdminNoticeModal/hide'
    }),

    init () {
      this.loading = true

      //TODO
      let serviceParams = {}

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}